<template>
  <div class="user-center">
    <div class="top">
      <Top />
    </div>

    <!-- 图表 -->
    <div class="charts">
      <a-radio-group slot="title"  defaultValue="WEEK" buttonStyle="solid" style="position:absolute;right:36px;top:6px;z-index:100" @change="expireChange">
        <a-radio-button value="WEEK">周</a-radio-button>
        <a-radio-button value="MONTH">月</a-radio-button>
        <a-radio-button value="YEAR">年</a-radio-button>
      </a-radio-group>
      <a-tabs defaultActiveKey="1" @change="tabChange">
        
        <a-tab-pane tab="企业用户数" key="user">  
          <!-- <h3></h3> -->
          <ve-line v-if="showCharts" ref="line" :legend-visible="false" :data="chartData" :yAxis="yAxis"></ve-line>
        </a-tab-pane>
        <a-tab-pane tab="证书报告数" key="cert" forceRender>
          <ve-line v-if="showCharts" ref="line" :legend-visible="false" :data="chartData1" :yAxis="yAxis"></ve-line>
        </a-tab-pane>
      </a-tabs>
      
    </div>
    <div class="right-menu">
        <ul>
            <li class="we-chat">
                <i class="iconfont icon">&#xe617;</i>
                <span class="max-text"><i class="iconfont">&#xe617;</i>微信咨询</span>
                <div class="we-img">
                    <div class="img"></div>
                </div>
            </li>
            <li>
                <i class="iconfont icon">&#xe613;</i>
                <span class="max-text"><i class="iconfont">&#xe613;</i>19906876274</span>
            </li>
            <li onclick="qimoChatClick()">
                <i class="iconfont icon">&#xe612;</i>
                <span class="max-text"><i class="iconfont">&#xe612;</i>在线咨询</span>
            </li>
        </ul>
    </div>

  </div>
</template>

<script>
import Top from "@/components/users/admin/userCenter/Top.vue";
import {adminUserMap} from '@/api/user'
export default {
  components: { Top },
  data() {
    
    // this.chartSettings = {
    //   stack: { '用户': ['num', '下单用户'] }
    // }
    return {
      
      yAxis:[
        {
          type:'value',
          minInterval:1  //y轴整数
        }
      ],
      showCharts: false,
      chartData: {
        columns: ['日期', '数量'],
        rows: [
        ]
      },
      chartData1: {
        columns: ['日期', '数量'],
        rows: []
      },
      state: 1,
      date:'WEEk', //默认月份
      type:'user'  // 默认数量类型
    };
  },
  created() {
    this.getAdminUserMap(this.type,this.date)
    
  },
  mounted() {
    this.$nextTick( _ => {
      this.showCharts = true
      setTimeout(() => {
        if(this.$refs.line.echarts.resize) {
          this.$refs.line.echarts.resize()
        }
      }, 100);
    })
  },

  methods: {  
    
    async getAdminUserMap(type,date){
      let params = {
        type : type,
        date :  date
      }
      try {
        let data = await adminUserMap(params)
       let newDatas=[]
        data.map(item => {
          let keyMap ={'date':'日期','num':'数量'}
          let objs = Object.keys(item).reduce((newData, key) => {
            let newKey = keyMap[key] || key
            newData[newKey] = item[key]
            return newData
          }, {})
         newDatas.push(objs)
        })
        if(type=='user'){
          this.chartData.rows = newDatas
        }else if(type=='cert')
        this.chartData1.rows = newDatas
      }catch(error){
        console.log(error)
      }
    },

    // 图表tab页切换
    tabChange(value) {
      this.type = value;
      this.getAdminUserMap(this.type,this.date)
    },
    //  周月年切换
    expireChange(e){
      this.date = e.target.value
      this.getAdminUserMap(this.type,this.date)
    }
  }
};
</script>

<style lang="less" scoped>
.user-center {
  min-height: 100%;
  padding-bottom: 15px;

  .top {
    // padding: 0 15px;
    // margin: 15px 0;
    margin-bottom: 24px;
    .top-username {
      padding: 10px 0;
      font-size: 16px;
      padding: 15px 0 5px;
      border-bottom: 1px solid #eee;
      margin-bottom: 12px;
      color: #000;
    }
  }

  .charts {
    background-color: #fff;
    // margin: 0 15px;
    // padding: 0 15px;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,.1);
    border-radius: 4px;
    position: relative;
    .ant-card {
      
    }
  }
  .right-menu {
    width: 45px;
    border-radius: 4px;
    min-height: 350px;
    /* display: flex; */
      /* -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
    flex-direction: column; */
    position: fixed;
    z-index: 999;
    right: 0;
    bottom: 200px;
    li {
      width: 45px;
      height: 48px;
      line-height: 48px;
      background: rgba(53,63,88,0.66);
      border-bottom: 1px solid rgba(255, 255, 255, 0.4);
      cursor: pointer;
      color: #fff;
      text-align: center;
      font-size: 16px;
      position: relative;
      .we-img {
        position: absolute;
        width: 120px;
        height: 120px;
        left: -230px;
        top: 0;
        background-color: #fff;
        border-radius: 10px;
        display: none;
        .img {
          position: absolute;
          width: 90%;
          height: 90%;
          background: url('../../../assets/images/small-public.png') center no-repeat;
          background-size: 100% 100%;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }
      .icon {
        position: absolute;
        z-index: 2;
        font-size: 24px;
        display: block;
        width: 100%;
        height: 100%;
        background: rgba(53,63,88,0.66);
        left: 0;
        top: 0;
        transition: left 1.2s;
      }
      .max-text {
        display: block;
        position: absolute;
        width: 160px;
        height: 48px;
        line-height: 48px;
        z-index: 3;
        left: 60px;
        top: -1px;
        background-image: linear-gradient(to right, rgb(90,211,151), rgba(0,175,131,1));
        color: #fff;
        border-radius: 5px 0 0 5px;
        font-size: 18px;
        transition: left 1s;
        padding: 0 10px;
        box-sizing: border-box;
        i{
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }
    li:last-child {
      border: none;
    }
    li:hover .max-text{
      left: -115px;
    }
    li:hover .icon {
      left: -20px;
    }
    .we-chat:hover .we-img{
      display: block;
    }
  }
}
</style>
